import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "utils/http";
import { CURRENCY } from "constants/api";

export interface IGetCurrencyResponse extends ApiResponse {
  data: ICurrency[];
}
interface IToggleCurrency extends ReduxAction {
  id: number;
  payload: IUpdateCurrency;
}
interface IUpdateLimit extends ReduxAction {
  data: IUpdateCurrencyLimit;
}
export interface IUpdateCurrencyArgs extends ReduxAction {
  payload: any;
  id: number;
}

export const getCurrencies = createAsyncThunk(
  CURRENCY.LIST,
  async ({ onFailure }: ReduxAction, { rejectWithValue }) => {
    try {
      const { data }: IGetCurrencyResponse = await axios.get(CURRENCY.LIST);
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const toggleCurrency = createAsyncThunk(
  CURRENCY.STATUS,
  async (
    { id, payload, onSuccess, onFailure }: IToggleCurrency,
    { rejectWithValue }
  ) => {
    try {
      const { message }: ApiResponse = await axios.patch(
        CURRENCY.STATUS.replace(":id", String(id)),
        payload
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const updateCurrencyLimit = createAsyncThunk(
  CURRENCY.UPDATE_LIMIT,
  async ({ data, onSuccess, onFailure }: IUpdateLimit, { rejectWithValue }) => {
    const { currencyId, updateKey, amountInValue } = data;

    try {
      const { message }: ApiResponse = await axios.put(
        CURRENCY.UPDATE_LIMIT.replace(":currencyId", String(currencyId)),
        {
          [updateKey]: amountInValue,
        }
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const updateCurrency = createAsyncThunk(
  CURRENCY.DETAIL,
  async (
    { payload, id, onSuccess, onFailure }: IUpdateCurrencyArgs,
    { rejectWithValue }
  ) => {
    try {
      const { message }: ApiResponse = await axios.put(
        CURRENCY.DETAIL.replace(":id", String(id)),
        payload
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);
